export const base64ToBlobUrl = (base64ImageData: string): string => {
  if (!base64ImageData) {
    return '';
  }

  // Extract contentType dynamically using regex
  const match = base64ImageData.match(/^data:(image\/[a-zA-Z+]+);base64,/);
  if (!match) {
    console.error('Invalid Base64 image data');
    return '';
  }

  const contentType = match[1]; // Extracted content type (e.g., image/png, image/jpeg, image/svg+xml)
  const base64Data = base64ImageData.replace(/^data:image\/[a-zA-Z+]+;base64,/, ''); // Remove the Base64 prefix

  try {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Error decoding Base64 image:', error);
    return '';
  }
};

export const hydraScoreRating = (hydraScore: any) => {
  if (hydraScore === 'NR') return 'Not Yet Rated'
  hydraScore = parseInt(hydraScore)
  if (hydraScore >= 93) return 'Excellent'
  if (hydraScore >= 79) return 'Good'
  if (hydraScore >= 68) return 'Average'
  if (hydraScore >= 48) return 'Marginal'
  return 'Poor'
}

export const normalizeKeys = (obj: any): any => {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => normalizeKeys(item))
  }

  return Object.keys(obj).reduce<{ [key: string]: any }>((acc, key) => {
    const normalizedKey = key.toLowerCase()
    const value = obj[key]
    acc[normalizedKey] = value
    return acc
  }, {})
}

export const getCropData = (cropData: any) => {
  const transformedData = Object.keys(cropData).reduce((acc: any, key) => {
    const newKey = key.replace(/_/g, ' ') // Replace underscores with spaces
    const value = cropData[key]

    // Check if percentage is less than 5
    if (value < 5) {
      acc.Other = (acc.Other || 0) + value // Accumulate values for "Other"
    } else {
      acc[newKey] = value // Replace the key with spaces
    }

    return acc
  }, {})

  // If "Other" exists, add it to the transformed data
  if (transformedData.Other) {
    transformedData.Other = parseFloat(transformedData.Other.toFixed(2)) // Round to 2 decimal places
  }
  const sortedArray = Object.entries(transformedData)
    .filter(([key]) => key !== 'Other')
    .sort(([, valueA], [, valueB]) => (valueB as number) - (valueA as number))

  const sortedObject = {
    ...Object.fromEntries(sortedArray),
    ...{ Other: transformedData['Other'] },
  }
  const totalSum = Object.values(sortedObject).reduce(
    (acc, curr) => acc + curr,
    0
  )

  // Ensure the total does not exceed 100%
  if (totalSum > 100) {
    // Calculate the maximum permissible value for "Other"
    const maxOther = 100 - (totalSum - sortedObject['Other'])

    // Adjust "Other" value to be the minimum of its current value or maxOther
    sortedObject['Other'] = Math.min(maxOther, sortedObject['Other']).toFixed(2)
  }

  return sortedObject
}
